// extracted by mini-css-extract-plugin
export default {"qrCodeBlock":"QRcode_qrCodeBlock__qiqf+","qrBlockImg":"QRcode_qrBlockImg__+C5eT","logoBlock":"QRcode_logoBlock__sEfar"};